import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, TrendingDown, HelpCircle } from 'lucide-react';
export function PainValidation() {
  const painPoints = [{
    icon: HelpCircle,
    text: 'Llegás a fin de mes preguntándote ¿en qué se me fue la plata?'
  }, {
    icon: TrendingDown,
    text: 'Pagás cuentas y cuotas pero sentís que nunca avanzás.'
  }, {
    icon: AlertCircle,
    text: 'El estrés financiero no te deja dormir tranquilo.'
  }];
  return <section className="py-20 bg-white" data-id="element-98">
      <div className="container mx-auto px-4 md:px-6" data-id="element-99">
        <div className="max-w-3xl mx-auto" data-id="element-100">
          <div className="text-center mb-12" data-id="element-101">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-102">
              No es que ganes poco, es que falta claridad
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-lg text-stone-600 leading-relaxed" data-id="element-103">
              La frustración de trabajar todo el mes y sentir que el dinero se
              escapa de las manos es agotadora. No se trata de cuánto ganás,
              sino de no tener un sistema que te muestre la realidad de tus
              números. Sin claridad, es imposible tomar buenas decisiones.
            </motion.p>
          </div>

          <div className="grid gap-6 md:grid-cols-3" data-id="element-104">
            {painPoints.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2 + index * 0.1
          }} className="bg-stone-50 p-6 rounded-2xl border border-stone-100 text-center hover:shadow-md transition-shadow" data-id="element-105">
                <div className="w-12 h-12 mx-auto bg-red-50 rounded-full flex items-center justify-center mb-4" data-id="element-106">
                  <point.icon className="w-6 h-6 text-red-400" data-id="element-107" />
                </div>
                <p className="text-stone-700 font-medium" data-id="element-108">{point.text}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}